import { defineMessages } from 'react-intl';

// Catalog for all volto-lightbox user-facing strings. Existing
// imageGalleryLightbox* msgids are preserved verbatim from the
// pre-extraction Lightbox.jsx + Schema.js to keep any future workspace
// i18n harvest output stable. New backdrop / palette msgids use the
// `lightboxBackdrop*` / `lightboxPalette*` namespaces for discoverability.
export const lightboxMessages = defineMessages({
  // -- Existing UI labels (msgids verbatim from DR-2026-122) --
  close: {
    id: 'imageGalleryLightboxClose',
    defaultMessage: 'Close',
  },
  previous: {
    id: 'imageGalleryLightboxPrevious',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'imageGalleryLightboxNext',
    defaultMessage: 'Next',
  },
  zoomIn: {
    id: 'imageGalleryLightboxZoomIn',
    defaultMessage: 'Zoom in',
  },
  zoomOut: {
    id: 'imageGalleryLightboxZoomOut',
    defaultMessage: 'Zoom out',
  },
  fullscreenEnter: {
    id: 'imageGalleryLightboxFullscreenEnter',
    defaultMessage: 'Fullscreen',
  },
  fullscreenExit: {
    id: 'imageGalleryLightboxFullscreenExit',
    defaultMessage: 'Exit fullscreen',
  },
  // -- Existing schema labels (msgids verbatim from DR-2026-122) --
  lightboxFieldsetTitle: {
    id: 'imageGalleryLightboxSection',
    defaultMessage: 'Lightbox',
  },
  enableLightbox: {
    id: 'imageGalleryEnableLightbox',
    defaultMessage: 'Enable click-to-enlarge lightbox',
  },
  lightboxZoom: {
    id: 'imageGalleryLightboxZoom',
    defaultMessage: 'Enable zoom in lightbox',
  },
  lightboxFullscreen: {
    id: 'imageGalleryLightboxFullscreen',
    defaultMessage: 'Enable fullscreen button in lightbox',
  },
  lightboxCounter: {
    id: 'imageGalleryLightboxCounter',
    defaultMessage: 'Show image counter (1 / N)',
  },
  // -- New backdrop schema labels --
  backdropPaletteTitle: {
    id: 'lightboxBackdropPaletteTitle',
    defaultMessage: 'Backdrop',
  },
  backdropCustomColorTitle: {
    id: 'lightboxBackdropCustomColorTitle',
    defaultMessage: 'Custom backdrop color',
  },
  backdropCustomOpacityTitle: {
    id: 'lightboxBackdropCustomOpacityTitle',
    defaultMessage: 'Custom backdrop opacity (%)',
  },
  // -- New palette choice labels --
  paletteDark: {
    id: 'lightboxPaletteDark',
    defaultMessage: 'Dark',
  },
  paletteCharcoal: {
    id: 'lightboxPaletteCharcoal',
    defaultMessage: 'Charcoal',
  },
  paletteOffWhite: {
    id: 'lightboxPaletteOffWhite',
    defaultMessage: 'Off-white',
  },
  paletteCream: {
    id: 'lightboxPaletteCream',
    defaultMessage: 'Cream',
  },
  paletteSepia: {
    id: 'lightboxPaletteSepia',
    defaultMessage: 'Sepia',
  },
  paletteCustom: {
    id: 'lightboxPaletteCustom',
    defaultMessage: 'Custom…',
  },
});

// Map palette id → message descriptor for use by schema.js.
// Internal — not re-exported from index.js. Schema-internal mapping
// shape may change in a future DR (e.g. when palette-extension hook
// lands per spec §"Forward-compatibility Hooks").
export const PALETTE_LABEL_KEY = {
  dark: lightboxMessages.paletteDark,
  charcoal: lightboxMessages.paletteCharcoal,
  'off-white': lightboxMessages.paletteOffWhite,
  cream: lightboxMessages.paletteCream,
  sepia: lightboxMessages.paletteSepia,
  custom: lightboxMessages.paletteCustom,
};
